import { useQueryClient } from 'react-query';
import moment from 'moment';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
export const useLocalAppointmentCreation = () => {
    const queryClient = useQueryClient();
    const mutate = useCallback((data) => {
        const queries = queryClient.getQueriesData(CacheKeys.APPOINTMENTS);
        for (const query of queries) {
            const key = query[0];
            const predicate = key[1];
            queryClient.setQueryData(key, (prev) => {
                if (!prev)
                    return undefined;
                if (predicate &&
                    ((predicate.thread && data.thread !== predicate.thread) ||
                        (predicate.from && moment(data.time).isBefore(predicate.from)) ||
                        (predicate.to && !moment(data.time).isBefore(predicate.to))))
                    return prev;
                const nextPagesArray = prev.pages.map((page, i) => {
                    if (i !== 0)
                        return page;
                    return {
                        records: [...page.records, data].sort((a, b) => moment(b.time).diff(a.time)),
                        meta: page.meta
                    };
                });
                return {
                    pages: nextPagesArray,
                    pageParams: prev.pageParams
                };
            });
        }
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalAppointmentCreation.js.map